import React from "react";
import "./Nav.css";
import logo from "../../Asset/logo.png";
const Nav = () => {
  return (
    <div className="Nav">
      <div className="logoContainer">
        <img src={logo} alt="logo" />
      </div>
      <div className="navMenuContainer"></div>
      <button>Let's Explore</button>
    </div>
  );
};

export default Nav;
